import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginService, logoutService, refreshTokenService } from "apis/Service";
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { BASE_URL } from "store/baseConfig";

const cookies = new Cookies();
axios.defaults.baseURL = BASE_URL;
axios.defaults.withCredentials = true;

const login = createAsyncThunk(
    'auth/login',
    async (data, thunkAPI) => {
        try {
            const resp = await loginService(data)
            return resp
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || '로그인 실패')
        }
    }
)

const logout = createAsyncThunk(
    'auth/logout',
    async (data, thunkAPI) => {
        const { getState } = thunkAPI
        const { auth } = getState()
        const { loginState, loginUserInfo } = auth

        if (loginState) {
            try {
                const resp = await logoutService(loginUserInfo.refresh, loginUserInfo.access)
                console.log(resp)
                if (resp.status === 200) {
                    localStorage.removeItem('selectCompanyNo');
                    localStorage.removeItem('companyMenuItems');
                    localStorage.removeItem('contractDate');

                    return resp.data
                }
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response?.data || '로그아웃 실패');
            }
        }
        return thunkAPI.rejectWithValue('로그인 상태가 아닙니다');
    }
)

const refreshToken = createAsyncThunk(
    'auth/refreshToken',
    async (data, thunkAPI) => {
        const { getState } = thunkAPI
        const { auth } = getState()
        const { loginState, loginUserInfo } = auth
        try {
            const response = await refreshTokenService(loginUserInfo.refresh, loginUserInfo.access);
            // refreshTokenService는 이미 resp.data를 반환하므로 그대로 전달
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
)

const changePassword = createAsyncThunk(
    'auth/changePassword',
    async (data, { getState }) => {
        const { auth } = getState()
        const { loginState, loginUserInfo } = auth

        const { currentPassword, newPassword } = data

        const cookies = new Cookies();

        if (loginState) {

            const url = '/change-password/'
            const urlHeaders = {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': cookies.get('csrftoken')
                },
            }

            try {
                const resp = await axios.post(url, { currentPassword, newPassword }, urlHeaders)
                if (resp.status === 200) {
                    return resp.data
                }
            } catch (e) {
                console.log(e)
                throw new Error('비밀번호 변경 실패');
            }
        }
    }
)

const setLoginInfo = createAsyncThunk(
    'auth/setLoginInfo',
    async (data, thunkAPI) => {
        // access 토큰은 필수
        if (!data.access) {
            return thunkAPI.rejectWithValue('Invalid login info format: access token is required');
        }
        // refresh 토큰과 user 정보는 선택적 (token만 있는 경우 user 정보를 나중에 가져올 수 있음)
        return data;
    }
)

/*
    loginUserInfo: {
    "access": "",
    "refresh": "",
    "user": {
        "login_id": "",
        "perm_id": "",
        "corp_no": 123,
        "dept_no": 123,
        "empl_no": 1
    }
}
*/
export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        loginState: false,
        loginUserInfo: {},
        isMobileLogin: false // 모바일 로그인 여부
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state, action) => {

            }).addCase(login.fulfilled, (state, action) => {
                state.loginState = true;
                state.loginUserInfo = action.payload;
                state.isMobileLogin = false; // 일반 로그인은 모바일 로그인이 아님
            }).addCase(login.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
                state.isMobileLogin = false;
            }).addCase(logout.pending, (state, action) => {

            }).addCase(logout.fulfilled, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
                state.isMobileLogin = false;
            }).addCase(logout.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
                state.isMobileLogin = false;
                cookies.remove('csrftoken');
            }).addCase(refreshToken.pending, (state, action) => {
            }).addCase(refreshToken.fulfilled, (state, action) => {
                state.loginState = true;
                if (action.payload && action.payload.access) {
                    state.loginUserInfo['access'] = action.payload.access;
                }
                if (action.payload && action.payload.refresh) {
                    state.loginUserInfo['refresh'] = action.payload.refresh;
                }
            }).addCase(refreshToken.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            }).addCase(changePassword.pending, (state, action) => {

            }).addCase(changePassword.fulfilled, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            }).addCase(changePassword.rejected, (state, action) => {

            }).addCase(setLoginInfo.fulfilled, (state, action) => {
                state.loginState = true;
                state.loginUserInfo = action.payload;
                state.isMobileLogin = true; // MobileLogin.js를 거쳐서 로그인한 경우
            }).addCase(setLoginInfo.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
                state.isMobileLogin = false;
            });
    }
});

export { changePassword, login, logout, refreshToken, setLoginInfo };

// Selectors
export const selectIsMobileLogin = (state) => state.auth.isMobileLogin;

export default authSlice.reducer;